import React, { useCallback } from "react";
import { connect } from "react-redux";

import notification from "antd/es/notification";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import { Button } from "@mapmycustomers/ui";

import { cloneCustomField, editField } from "../../store/actions";

import messages from "./messages";

const NOTIFICATION_KEY = "customFieldCloned";

interface Props {
  disabled: boolean;
  field: SchemaField;
  onCloneCustomField: typeof cloneCustomField.request;
  onEdit: typeof editField.request;
}

const CloneActionMenuLabel: React.FC<Props> = ({ disabled, field, onCloneCustomField, onEdit }) => {
  const intl = useIntl();

  const handleEdit = useCallback(
    (field: SchemaField) => {
      notification.close(NOTIFICATION_KEY);
      onEdit(field.id);
    },
    [onEdit]
  );

  const handleCloned = useCallback(
    (field: SchemaField) => {
      notification.success({
        btn: (
          <Button onClick={() => handleEdit(field)} size="small">
            {intl.formatMessage(messages.successEditButtonTitle)}
          </Button>
        ),
        description: intl.formatMessage(messages.successDescription),
        key: NOTIFICATION_KEY,
        message: intl.formatMessage(messages.successMessage),
      });
    },
    [intl, handleEdit]
  );

  const handleClone = useCallback(() => {
    onCloneCustomField({
      callback: handleCloned,
      data: {
        customFieldId: field.customFieldId!,
      },
    });
  }, [handleCloned, onCloneCustomField, field]);

  return (
    <Tooltip placement="left" title={disabled ? intl.formatMessage(messages.disabled) : null}>
      <span onClick={handleClone}>{intl.formatMessage(messages.copy)}</span>
    </Tooltip>
  );
};

const mapDispatchToProps = {
  onCloneCustomField: cloneCustomField.request,
  onEdit: editField.request,
};

export default connect(null, mapDispatchToProps)(CloneActionMenuLabel);
